export const dynamicDataZindex = 0.5
export const dynamicDataAnimationZindex = 1